<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">IMPORTAR KMZ DE FIBRA</li>
                </ol>

                <form method="POST" action="#" enctype="multipart/form-data">
                    <!-- COMPONENT START -->
                    <div class="form-group">
                        <div class="input-group input-file" name="Fichier1">
                            <input type="text" class="form-control" placeholder="Escolha um Arquivo" />
                            <span class="input-group-btn">
                            <button class="btn btn-default btn-choose" type="button">SELECIONE UM ARQUIVO</button>
                        </span>

                        </div>
                    </div>
                    <!-- COMPONENT END -->
                    <div class="form-group">
                        <button type="button" @click="send()" class="btn btn-primary pull-right" :disabled="!record">ENVIAR</button>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
import { Upload } from "../../class/upload";
/* global $ swal*/
export default {
    name: "ImportarKMZ",
    data() {
        return {
            record: null
        };
    },
    mounted() {
        let el = this;
        $(".input-file").before(function() {
            if (
                !$(this)
                    .prev()
                    .hasClass("input-ghost")
            ) {
                var element = $(
                    "<input type='file' class='input-ghost' @change='upload' name='upload.kmz' accept='application/vnd.google-earth.kmz' style='visibility:hidden; height:0'>"
                );
                // element.attr("name", $(this).attr("name"));
                element.change(() => {
                    let files = element[0].files;

                    let data = new FormData();
                    data.append("file", files[0]);
                    data.append("name", element[0].name);

                    el.change(data);

                    element
                        .next(element)
                        .find("input")
                        .val(
                            element
                                .val()
                                .split("\\")
                                .pop()
                        );
                });
                $(this)
                    .find("button.btn-choose")
                    .click(function() {
                        element.click();
                    });
                $(this)
                    .find("input")
                    .css("cursor", "pointer");
                $(this)
                    .find("input")
                    .mousedown(function() {
                        $(this)
                            .parents(".input-file")
                            .prev()
                            .click();
                        return false;
                    });
                return element;
            }
        });
    },
    methods: {
        change(data) {
            this.record = data;
        },
        send() {
            swal.queue([
                {
                    title: "UPLOAD",
                    text: "Você enviar o arquivo?",
                    showCancelButton: true,
                    type: "warning",
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, pode enviar!",
                    showLoaderOnConfirm: true,
                    preConfirm: async () => {
                        await Upload.post(this.record);
                        this.record = null;
                        swal(
                            "UPLOAD!",
                            "O arquivo foi enviado com sucesso!",
                            "success"
                        );
                    }
                }
            ]);
        }
    }
};
</script>

<style scoped>
</style>
